import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Placement } from "react-bootstrap/esm/Overlay";

export const IOTPToolTip = ({
    children,
    message,
    placement = undefined,
    preserveWhitespace = false,
}: {
    children: React.ReactElement;
    message: string;
    placement?: Placement;
    preserveWhitespace?: boolean;
}) => {
    return (
        <OverlayTrigger
            placement={placement}
            overlay={
                <Tooltip 
                    id="tooltip-iotp"
                    className={preserveWhitespace ? 'preserve-whitespace' : ''}
                >
                    {message}
                </Tooltip>
            }
        >
            {children}
        </OverlayTrigger>
    );
};
